export default __webpack_public_path__ + "static/media/Ies_MesasCruzadas_CarrieACCESO.a507b02f.jpg";